const MediaTagsColors = {
  Cases: '#A8DADC',
  Transmission: '#F9C5D1',
  Prevention: '#B5EAD7',
  Surveillance: '#FFD6A5',
  Deaths: '#F6B6B6',
  Hospitalisations: '#C7CEEA',
  Treatment: '#FFE5B4',
  Investigation: '#A7E9AF',
  Recall: '#FBC4AB',
  Zoonosis: '#BDE0FE',
  Travel: '#FFDAC1',
  'Climate change': '#C1E1C1',
  Restrictions: '#E2F0CB',
  Finances: '#D5E1DF',
  Deal: '#FFDEDE',
  'Monoclonal Antibodies': '#E4C1F9',
  'Regulatory Approval': '#B5EAEA',
  Drug: '#FFCCD5',
  'Human Trials': '#D6E5FA',
  'Research and Development': '#FDFD96',
  Location: '#F8EDEB',
  'Treatment Effectiveness': '#B5D5C5',
  'Mechanism of Action': '#F6D7A7',
  'Treatment Delivery': '#E2CFC4',
  Procurement: '#D3F8E2',
  Supply: '#E0BBE4',
  Doses: '#FDCB82',
  Collaboration: '#AFCBFF',
  'Preclinical Development': '#FFB5A7',
  Review: '#BFD7EA',
  'Treatment Identification': '#FFE1E0',
  'Phase I Trials': '#C2F0C2',
  Business: '#FFF1BA',
} as Record<string, string>

export default MediaTagsColors
